module.exports = __webpack_public_path__ + "static/serviceDevelopment-b1294f6f637a2b840bdfb73175464a67.png";